import { isAfter, parseISO } from 'date-fns';
import { useMemo } from 'react';

import { INDBFlow } from '@/helpers/NDBFlow';
import {
  groupMemberNoDeposits,
  groupMemberNotConfirmedNDB,
} from '@/helpers/user';
import { STORAGE, useCommonStore, useLocalStorageStore } from '@/store';

const RELEASE_NDB_FLOW_DATE = parseISO('2025-08-07T00:00:00Z');

export const useNDBFlow = () => {
  const user = useCommonStore.use.user();
  const localNDBFlow = useLocalStorageStore
    .getState()
    .get<INDBFlow | null>(STORAGE.NDB_FLOW);

  const { isNDBFlow, isAfterReleaseDate, isNoDepositUser } = useMemo(() => {
    const isNoDepositUser = groupMemberNoDeposits(user);
    const isNotConfirmedNDBUser = groupMemberNotConfirmedNDB(user);
    const isAfterReleaseDate =
      !!user?.confirmedAt &&
      isAfter(
        parseISO(user.confirmedAt.replace(' UTC', 'Z')),
        RELEASE_NDB_FLOW_DATE
      );

    const isNDBFlow =
      !!localNDBFlow?.isNDBFlow || (isNotConfirmedNDBUser && isNoDepositUser);

    return {
      isNDBFlow,
      isAfterReleaseDate,
      isNoDepositUser,
    };
  }, [user]);

  return {
    isNDBFlow,
    localNDBFlow,
    isAfterReleaseDate,
    isNoDepositUser,
  };
};
